/**
 * Walking on nodes tree from the element to root or provided end element.
 * Do not visit the sibling and children.
 *
 * @param node start node
 * @param nodeAction action for every node, if return false walk will be break
 */
export function walkToTop(node, nodeAction) {
    if (nodeAction(node) !== false && node.parentNode !== null) {
        walkToTop(node.parentNode, nodeAction);
    }
}
/**
 * Return first ancestor, for wich predicate returns true
 * If nothing found, returns null
 */
export function findAncestor(node, predicate) {
    var ancestor = null;
    walkToTop(node.parentNode, function (candidate) {
        if (predicate(candidate)) {
            ancestor = candidate;
            return false;
        }
    });
    return ancestor;
}
